module.exports = __webpack_public_path__ + "static/media/pin.8737340d.svg";